import { makeStyles } from '@mui/styles';
import backgroundImage from 'src/assets/images/homePage.png';
import backgroundImageMobile from 'src/assets/images/mobileHome.png';

const useStyles = makeStyles({
  container: {
    minHeight: '100vh',
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top right',
    '@media (max-width: 640px)': {
      backgroundImage: `url(${backgroundImageMobile})`,
      backgroundPosition: 'calc(50% - 160px) -12rem'
    },

    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    padding: '24px',
    '@media (max-width: 640px)': {
      paddingTop: '232px'
    },
    boxSizing: 'border-box'
  }
});

export default useStyles;
